import { useQuery } from '@tanstack/react-query';

import { cartQuery } from './cartQuery';

export const useCart = (enabled = true) => useQuery({ ...cartQuery(), enabled });
